import { render, staticRenderFns } from "./OrderModelInsole.vue?vue&type=template&id=12b7d588&"
import script from "./OrderModelInsole.vue?vue&type=script&lang=js&"
export * from "./OrderModelInsole.vue?vue&type=script&lang=js&"
import style0 from "./OrderModelInsole.vue?vue&type=style&index=0&id=12b7d588&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports